import React, { type ReactNode } from 'react';
import { FILTER_PREFERENCE } from '@atlassian/jira-business-preferences/src/constants.tsx';
import { useViewPreference } from '@atlassian/jira-business-preferences/src/controllers/view-preferences-context/index.tsx';
import { InternalFiltersJqlProvider } from './index.tsx';

type Props = {
	children: ReactNode;
};

export const FiltersJqlProvider = ({ children }: Props) => {
	const [jql, saveFilters] = useViewPreference(FILTER_PREFERENCE);

	return (
		<InternalFiltersJqlProvider jql={jql} saveJql={saveFilters}>
			{children}
		</InternalFiltersJqlProvider>
	);
};
